export default "__VITE_ASSET__M47_pBjL__"